module.exports = __webpack_public_path__ + "static/empatia-b-9f03a02941b1e492a2ed019204136c0e.jpg";